import {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {updateStatus} from '../../../../../reducers/wheel/actions';
import Timer from '../../../../../utils/timer';

export default ({timestamp}) => {
    const [time, setTime] = useState(timestamp - Date.now()),
          dispatch = useDispatch();

    useEffect(() => {
        if(time >= 0)
            window.wheel_timer_timeout = setTimeout(() => {
                setTime(timestamp - Date.now());
            }, 500);
        else
            dispatch(updateStatus());

        return () => clearTimeout(window.wheel_timer_timeout);
    }, [time]);

    useEffect(() => {
        setTime(timestamp - Date.now());
    }, [timestamp]);

    const timer = Timer.parse(time < 0 ? 0 : time, true, false),
          day_timestamp = (24 * 60 * 60 * 1e3);

    return (
        <div className="status has_spin" style={{
            flexDirection: 'column-reverse',
            gap: '15px'
        }}>
            <div className="lines">
                You have reached the daily limit. The next spin will be available in
            </div>
            <div className="bottom">
                <div className="timer">
                    <div className="top">
                        <div className="title">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6673 7.99992C14.6673 11.6799 11.6807 14.6666 8.00065 14.6666C4.32065 14.6666 1.33398 11.6799 1.33398 7.99992C1.33398 4.31992 4.32065 1.33325 8.00065 1.33325C11.6807 1.33325 14.6673 4.31992 14.6673 7.99992Z" stroke="#E9974D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10.4739 10.1199L8.40724 8.88659C8.04724 8.67326 7.75391 8.15992 7.75391 7.73992V5.00659" stroke="#E9974D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            Wait timer
                        </div>
                        <div className="text">
                            {timer.hours}H {timer.minutes}M {timer.seconds}S
                        </div>
                    </div>
                    <div className="progress">
                        <div className="line" style={{width: `${(time / day_timestamp)*100}%`}}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}